@if (control) {
    @if (forceRequired || (required | async)) {
        <fui-mandatory-validation
            [control]="control"></fui-mandatory-validation>
    }
    <fui-error-validation [control]="control" [focussed]="focussed"
                          [verticalAlignment]="errorVerticalAlignment"></fui-error-validation>
    <fui-success-validation [control]="control"></fui-success-validation>
}
